import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import Typography from '@material-ui/core/Typography';

import IconButton from 'components/common/IconButton';
import Menu from 'components/common/Menu';
import DeleteMenu from 'components/common/DeleteMenu';
import IconDocument from 'components/icons/IconDocument';
import IconTrashCan from 'components/icons/IconTrashCan';
import IconInfo from 'components/icons/IconInfo';
import IconPen from 'components/icons/IconPen';
import Link from 'components/common/Link';
import Chip from 'components/common/Chip';

import formatUtcToLocalDate from 'utils/formatUtcToLocalDate';
import pxToRem from 'styles/pxToRem';

import dateFormat from 'config/dateFormat';
import timeDateFormat from 'config/timeDateFormat';

import { removePatientResource } from 'redux/modules/patients';
import { deletePatientDocument } from 'redux/modules/patientsDocuments';
import { downloadExplainPatientInsuranceEligibility } from 'redux/modules/patientsInsurance';

import DocumentsForm from './DocumentsForm';

const styles = theme => ({
  root: {
    padding: '20px 0',
    alignItems: 'flex-start',
    '& + $root': {
      borderTop: `1px solid ${theme.palette.primary.A100}`,
    },
  },
  body: {
    width: '100%',
    paddingLeft: 15,
    paddingRight: 70,
  },
  bodyEligibility: {
    paddingRight: 110,
  },
  bodyEdit: {
    paddingRight: 15,
  },
  listItemSecondaryAction: {
    top: 10,
    margin: '0 -15px 0 0',
    transform: 'none',
  },
  button: {
    width: 42,
    height: 42,
  },
  typographyDate: {
    display: 'inline-block',
    marginRight: 15,
    fontSize: pxToRem(12),
  },
  typographySize: {
    display: 'inline-block',
    fontSize: pxToRem(12),
  },
  iconDocument: {
    width: 16,
    height: 20,
    margin: '5px 3px 0 3px',
    color: theme.palette.primary.A400,
  },
  iconTrashCan: {
    width: 14,
    height: 18,
  },
  iconPen: {
    width: 16,
    height: 16,
  },
  iconInfo: {
    width: 19,
    height: 19,
  },
  chipCategory: {
    marginRight: 4,
    marginBottom: 4,
  },
  categories: {
    marginTop: 8,
    marginBottom: -4,
  },
});

class DocumentsItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: props.dropped || false,
      anchorEl: null,
    };

    this.onMenuClose = this.onMenuClose.bind(this);
    this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
    this.onRemoveCancel = this.onRemoveCancel.bind(this);
    this.onRemoveSubmit = this.onRemoveSubmit.bind(this);
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
    this.onCancelButtonClick = this.onCancelButtonClick.bind(this);
    this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
    this.onMouseOver = this.onMouseOver.bind(this);
    this.onFormChange = this.onFormChange.bind(this);
  }

  componentDidMount() {
    const { dropped } = this.props;
    setTimeout(() => {
      if (this.textFieldRef) {
        this.textFieldRef.focus();
      }
    }, 100);
    if (dropped) {
      this.droppedFocusedTimeout = setTimeout(() => {
        this.setState({ edit: false });
      }, 5000);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { dropped } = this.props;
    if (dropped && !nextProps.dropped) {
      this.setState({ edit: false });
      if (this.droppedFocusedTimeout) {
        clearTimeout(this.droppedFocusedTimeout);
      }
    }
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onRemoveButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget,
    });
  }

  onRemoveCancel() {
    this.setState({ anchorEl: null });
  }

  onRemoveSubmit() {
    if (this.props['In SMS']) {
      this.props.actions.removePatientResource({
        'Record Number': this.props['Record Number'],
        'Document ID': [this.props.ID],
      });
    } else {
      this.props.actions.deletePatientDocument({
        'Record Number': this.props['Record Number'],
        ID: this.props.ID,
      });
    }
    this.setState({ anchorEl: null });
  }

  onEditButtonClick() {
    this.setState({ edit: true });
    setTimeout(() => {
      if (this.textFieldRef) {
        this.textFieldRef.focus();
      }
    }, 100);
  }

  onCancelButtonClick() {
    this.setState({ edit: false });
  }

  onSubmitSuccess() {
    this.setState({ edit: false });
  }

  onMouseOver() {
    const { dropped } = this.props;
    if (dropped && this.droppedFocusedTimeout) {
      clearTimeout(this.droppedFocusedTimeout);
    }
  }

  onFormChange() {
    const { dropped } = this.props;
    if (dropped && this.droppedFocusedTimeout) {
      clearTimeout(this.droppedFocusedTimeout);
    }
  }

  render() {
    const { ID, account, classes } = this.props;
    const { edit } = this.state;
    const open = Boolean(this.state.anchorEl);
    const eligibilityID = this.props['File Name'].indexOf('Eligibility') !== -1
      && this.props['File Name'].indexOf('-') !== -1
      ? Number(this.props['File Name'].replace('.pdf', '').split('-').reverse()[0]) : null;
    return (
      <ListItem
        className={classes.root}
        onMouseOver={this.onMouseOver}
      >
        <IconDocument className={classes.iconDocument} />
        <div
          className={classNames(classes.body, {
            [classes.bodyEligibility]: eligibilityID,
            [classes.bodyEdit]: edit,
          })}
        >
          <div className={classes.header}>
            <Typography gutterBottom>
              <Link onClick={() => { this.props.onClick(this.props.ID); }}>
                {this.props['File Name']}
              </Link>
            </Typography>
            <Typography
              className={classes.typographyDate}
              component="time"
              color="secondary"
              dateTime={formatUtcToLocalDate(
                this.props['Create At'],
                timeDateFormat,
                dateFormat,
                this.props.business['Company Address']['Time Zone'],
                this.props.business['Company Address']['Observes Daylight Saving'],
              )}
            >
              {formatUtcToLocalDate(
                this.props['Create At'],
                timeDateFormat,
                dateFormat,
                this.props.business['Company Address']['Time Zone'],
                this.props.business['Company Address']['Observes Daylight Saving']
              )}
            </Typography>
            <Typography
              className={classes.typographySize}
              component="span"
              color="secondary"
            >
              {this.props['File Size']}
            </Typography>
          </div>
          {edit ? (
            <DocumentsForm
              form={`patientDocumentEdit-${ID}`}
              initialValues={{
                ID,
                'Document Category': this.props['Document Category'].map(item => ({
                  label: item.Name,
                  value: item.ID,
                })),
              }}
              onCancelButtonClick={this.onCancelButtonClick}
              onSubmitSuccess={this.onSubmitSuccess}
              onFormChange={this.onFormChange}
              textFieldRef={(textFieldRef) => {
                this.textFieldRef = textFieldRef;
              }}
            />
          ) : (
            <Fragment>
              {this.props['Document Category'].length > 0 &&
                (<div className={classes.categories}>
                  {this.props['Document Category'].map(item => (
                    <Chip
                      key={item.ID || item.Name}
                      className={classes.chipCategory}
                      label={item.Name}
                      size="sm"
                      square
                    />
                  ))}
                </div>)}
              <ListItemSecondaryAction className={classes.listItemSecondaryAction}>
                {eligibilityID &&
                  <IconButton
                    className={classes.button}
                    onClick={() => {
                      this.props.actions.downloadExplainPatientInsuranceEligibility({
                        ID: eligibilityID,
                        fileName: `${this.props['File Name']}-Explain`,
                      });
                    }}
                    tooltipContent="Eligibility Details"
                  >
                    <IconInfo className={classes.iconInfo} />
                  </IconButton>
                }
                <IconButton
                  className={classes.button}
                  aria-label="Remove"
                  aria-owns={open ? `${this.props.ID}-document-remove-menu` : null}
                  aria-haspopup="true"
                  onClick={this.onRemoveButtonClick}
                  disabled={account.Roles.filter(item =>
                    item.Name === 'Master Administrator' || item.Name === 'Administrator' || item.Name === 'Manager').length === 0}
                  tooltipContent="Delete"
                >
                  <IconTrashCan className={classes.iconTrashCan} />
                </IconButton>
                <IconButton
                  className={classes.button}
                  onClick={this.onEditButtonClick}
                  tooltipContent="Edit"
                >
                  <IconPen className={classes.iconPen} />
                </IconButton>
                <Menu
                  id={`${this.props.ID}-document-remove-menu`}
                  anchorEl={this.state.anchorEl}
                  open={open}
                  onClose={this.onMenuClose}
                  list={false}
                >
                  <DeleteMenu
                    text="Are you sure you want to delete this document?"
                    onCancel={this.onRemoveCancel}
                    onSubmit={this.onRemoveSubmit}
                  />
                </Menu>
              </ListItemSecondaryAction>
            </Fragment>
          )}
        </div>
      </ListItem>
    );
  }
}

DocumentsItem.propTypes = {
  'Record Number': PropTypes.number.isRequired,
  ID: PropTypes.number.isRequired,
  'File Name': PropTypes.string.isRequired,
  'Create At': PropTypes.string.isRequired,
  'File Size': PropTypes.string.isRequired,
  'Document Category': PropTypes.arrayOf(PropTypes.shape({
    Name: PropTypes.string.isRequired,
  })),
  dropped: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    removePatientResource: PropTypes.func.isRequired,
    deletePatientDocument: PropTypes.func.isRequired,
    downloadExplainPatientInsuranceEligibility: PropTypes.func.isRequired,
  }).isRequired,
  account: PropTypes.shape({
    Roles: PropTypes.arrayOf(PropTypes.shape({
      Name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
    'Time Zone': PropTypes.string,
  }),
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
    listItemSecondaryAction: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    typographyDate: PropTypes.string.isRequired,
    typographySize: PropTypes.string.isRequired,
    iconDocument: PropTypes.string.isRequired,
    iconTrashCan: PropTypes.string.isRequired,
  }).isRequired,
};

DocumentsItem.defaultProps = {
  business: {},
  'Document Category': [],
  dropped: false,
};

const mapStateToProps = store => ({
  account: store.account,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    removePatientResource, deletePatientDocument, downloadExplainPatientInsuranceEligibility,
  }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(DocumentsItem),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Documents/DocumentsItem.js